import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
  standalone: true,
  name: 'wordsByCount'
})
export class WordByCountPipe implements PipeTransform {

  transform(word: string, count: number, withCount: boolean = true): string {
    return Utils.wordByCount(word, count, withCount);
  }

}
